import React, { useCallback, useRef, useState } from 'react';
import { numberToChinese } from '@/utils';
import { When } from '@/components';
import cx from './index.module.scss';

interface Props {
  imgs: string[];
}

const SlideImgs: React.FC<Props> = ({ imgs = [] }) => {
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0);
  const [currentIsSlideLeft, setCurrentIsSlideLeft] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = useCallback(event => {
    touchStartX.current = event.touches[0].clientX;
  }, []);

  const handleTouchMove = useCallback(event => {
    touchEndX.current = event.changedTouches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (!(touchEndX.current && touchStartX.current)) return;

    const pageLength = imgs?.length || 1;
    const difference = touchEndX.current - touchStartX.current;

    if (Math.abs(difference) < 30) {
      return;
    }

    setCurrentIsSlideLeft(difference < 0);

    const newIndex = currentActiveIndex + (difference < 0 ? 1 : -1);

    if (newIndex >= 0 && newIndex <= pageLength - 1) {
      setCurrentActiveIndex(newIndex);
    }
    touchStartX.current = 0;
    touchEndX.current = 0;
  }, [currentActiveIndex, imgs?.length]);

  return (
    <div
      className={cx('SlideImgs', { 'is-slide-left': currentIsSlideLeft })}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {imgs?.map((item, index) => (
        <div className={cx('img-item', { active: currentActiveIndex === index })} key={index}>
          <img src={item} alt="" />
        </div>
      ))}
      <When condition={imgs?.length > 1}>
        <div className={cx('indicator')}>
          {[...new Array(imgs?.length)].map((_, index) => (
            <div className={`${cx['item']} ${index === currentActiveIndex && cx['active']}`} key={index} />
          ))}
        </div>
        <div className={cx('step-info')}>步骤{numberToChinese(currentActiveIndex + 1)}</div>
      </When>
    </div>
  );
};

export default SlideImgs;
